import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AppSnackbarService, type SnackbarVariant } from '../../services/app-snackbar.service';

@Component({
  selector: 'lib-app-snackbar',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './app-snackbar.component.html',
  styleUrl: './app-snackbar.component.scss'
})
export class AppSnackbarComponent {
  protected readonly snackbar = inject(AppSnackbarService);

  protected hostRole(variant: SnackbarVariant): 'alert' | 'status' {
    return variant === 'error' ? 'alert' : 'status';
  }

  protected hostAriaLive(variant: SnackbarVariant): 'assertive' | 'polite' {
    return variant === 'error' ? 'assertive' : 'polite';
  }
}
